// new states
import { create } from "zustand";
import { persist } from "zustand/middleware";

const useQuizStore = create(
  persist(
    (set, get) => ({
      quizzes: [],
      streak: 0,
      date: new Date().toISOString(),

      setValues: values => set({ values }),
      setQuizzes: id => {
        const quizId = get().quizzes.find(itm => itm?.id === id);
        if (!quizId) {
          const quizzes = get().quizzes;
          quizzes.push({
            id,
            score: 10,
            attempt: 0,
            clue: "",
            clue1: false,
            clue2: false,
            clue3: false,
            focusedIndex: 0,
            highlightWord: "",
            highlightedQuestion: "",
            help: 0,
            completed: false,
          });
          set({ quizzes });
        }
      },
      getStreak: () => get().streak,
      getDate: () => get().date,
      getCompleted: id => {
        const _ = get().quizzes.find(itm => itm.id === id)?.completed || false;
        return _;
      },
      setCompleted: id => {
        const quizzes = [...get().quizzes];
        const quiz = quizzes.find(itm => itm.id === id);
        if (quiz) {
          const today = new Date();
          const lastDate = new Date(get().date);
          const diffHours = Math.abs(today - lastDate) / (1000 * 60 * 60);
          if (diffHours > 48) {
            set({ streak: 1 });
          } else {
            set(state => ({ streak: state.streak + 1 }));
          }
          set({ date: today.toISOString() });
          quiz.completed = true;
          set({ quizzes });
        }
      },
      getClue: id => {
        const clue = get().quizzes.find(itm => itm.id === id)?.clue || "";
        return clue;
      },
      setClue: (id, clue) => {
        let quizzes = [...get().quizzes];
        quizzes = quizzes.map(itm => (itm.id === id ? { ...itm, clue } : itm));
        set({ quizzes });
      },
      getHighlighted: id => {
        const clue = get().quizzes.find(itm => itm.id === id)?.highlightWord || "";
        return clue;
      },
      setHighlighted: (id, highlightWord) => {
        let quizzes = [...get().quizzes];
        quizzes = quizzes.map(itm => (itm.id === id ? { ...itm, highlightWord } : itm));
        set({ quizzes });
      },
      getScore: id => {
        const score = get().quizzes.find(itm => itm.id === id)?.score;
        return score;
      },
      setScore: (id, score) => {
        let quizzes = [...get().quizzes];
        quizzes = quizzes.map(itm => (itm.id === id ? { ...itm, score } : itm));
        set({ quizzes });
      },
      getHelp: id => {
        const help = get().quizzes.find(itm => itm.id === id)?.help;
        return help;
      },
      setHelp: (id, help) => {
        let quizzes = [...get().quizzes];
        quizzes = quizzes.map(itm => (itm.id === id ? { ...itm, help } : itm));
        set({ quizzes });
      },
      getAttempt: id => {
        const attempt = get().quizzes.find(itm => itm.id === id)?.attempt;
        return attempt;
      },
      setAttempt: (id, attempt) => {
        let quizzes = [...get().quizzes];
        quizzes = quizzes.map(itm => (itm.id === id ? { ...itm, attempt } : itm));
        set({ quizzes });
      },
      getFocusedIndex: id => {
        const focusedIndex = get().quizzes.find(itm => itm.id === id)?.focusedIndex || 0;
        return focusedIndex;
      },
      setFocusedIndex: (id, focusedIndex) => {
        let quizzes = [...get().quizzes];
        quizzes = quizzes.map(itm => (itm.id === id ? { ...itm, focusedIndex } : itm));
        set({ quizzes });
      },
      getHighlightedQuestion: id => {
        const highlightedQuestion =
          get().quizzes.find(itm => itm.id === id)?.highlightedQuestion || "";
        return highlightedQuestion;
      },
      setHighlightedQuestion: (id, highlightedQuestion) => {
        let quizzes = [...get().quizzes];
        quizzes = quizzes.map(itm => (itm.id === id ? { ...itm, highlightedQuestion } : itm));
        set({ quizzes });
      },
      getClueStatus: (id, clue) => {
        const _ = get().quizzes.find(itm => itm.id === id);
        return _[clue] || false;
      },
      setClueStatus: (id, clue) => {
        let quizzes = [...get().quizzes];
        quizzes = quizzes.map(itm => (itm.id === id ? { ...itm, [clue]: true } : itm));
        set({ quizzes });
      },
      incrementHelp: id => {
        let quizzes = [...get().quizzes];
        const quiz = quizzes.find(itm => itm.id === id);
        if (quiz) {
          quiz.help += 1;
          set({ quizzes });
          // Check if help state equals the answer length
          const answerLength = quiz?.answer?.length;
          if (quiz.help === answerLength) {
            quiz.completed = true;
            quiz.score = 0;
          }
        }
        set({ quizzes });
      },
    }),
    {
      name: "quiz-storage",
    },
  ),
);

export default useQuizStore;
